import React from "react";
import TopBar from "@insightfulscience/topbar";

export const HeaderTopBar = () => {
	return <TopBar brandCode="gn" />;
};
